import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';

import { HeaderProfileComponent } from './header-profile/header-profile.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'src/app/shared/shared.module';
import 'iconify-icon';

@NgModule({
  declarations: [
    HeaderComponent,
    HeaderProfileComponent,
    SidebarComponent
  ],
  imports: [
    CommonModule,
     RouterModule,
     MatButtonModule,
     MatMenuModule,
     MatIconModule,
     SharedModule
    ],
  exports: [HeaderComponent, HeaderProfileComponent, SidebarComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LayoutModule { }
